<template>
  <div class="c-shelf" :class="rootClasses">
    <div v-if="$slots.left" class="c-shelf-left c-shelf-section">
      <slot name="left"/>
    </div>
    <div v-else-if="$slots.default" class="c-shelf-left c-shelf-section">
      <slot/>
    </div>
    <div v-if="$slots.middle" class="c-shelf-middle c-shelf-section">
      <slot name="middle"/>
    </div>
    <div v-if="$slots.right" class="c-shelf-right c-shelf-section">
      <slot name="right"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  const props = withDefaults(defineProps<{
    align?: 'top' | 'center' | 'bottom'
  }>(), {
    align: 'center',
  });

  const rootClasses = computed(() => ({
    [`c-shelf-${props.align}`]: true,
  }));
</script>

<style lang="scss">
  .c-shelf {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: 0.5rem;
    width: 100%;

    * {
      // allow all descendants to shrink if needed
      min-width: 0;
    }

    &:has(&-middle) {
      display: grid;
      grid-template-columns: 1fr auto 1fr;

      .c-shelf-right {
        justify-self: end;
      }

      .c-shelf-middle {
        grid-column-start: 2;
      }
    }

    &-section {
      flex-shrink: 0;
      display: flex;
      gap: 0.5rem;
    }

    &-left {
      flex-shrink: 1;
    }

    &-top &-section {
      align-items: start;
    }

    &-center &-section {
      align-items: center;
    }

    &-bottom &-section {
      align-items: end;
    }
  }
</style>
